import React from 'react'

import { HeaderActionButton, HeaderSearchButton, HeaderActionIcon, HeaderActionText, HeaderActionsBlock, HintNumber } from './HeaderActions.styles'

import DynamicHeaderContainer from '../dynamicheader/DynamicHeader.container'

import Icon from '@emcm-ui/component-icon';

const HeaderActionsComponent = ({
  analytics,
  multiselect,
  selectedRows,
  api,
  children,
  handleExportOpenClick,
  handleFilterOpenClick,
  handleSearchOpenClick,
  i18n,
  filterDrawerOpen,
  filterCount,
  download,
  headerButtons,
  env }) => {
  let style = {}

  if (filterDrawerOpen) {
    style = {
      borderColor: '#4d4d4d'
    }
  }

  return (
    <HeaderActionsBlock>
      {download &&
        <HeaderActionButton onClick={handleExportOpenClick} data-testid='tool-button'>
          <HeaderActionIcon data-testid='tool-button-download'>
            <Icon
              path="./icons/ui/grey/download-07.svg"
              size="s"
            />
          </HeaderActionIcon>
          <HeaderActionText>
            {i18n.download}
          </HeaderActionText>
        </HeaderActionButton>
      }

      {headerButtons &&
        <DynamicHeaderContainer analytics={analytics} multiselect={multiselect} headerButtons={headerButtons} api={api} env={env} selectedRows={selectedRows} />
      }

      <HeaderActionButton onClick={handleFilterOpenClick} data-testid='tool-button'>
        {filterCount > 0 &&
          <HintNumber>{filterCount}</HintNumber>
        }
        <HeaderActionIcon style={style} data-testid='tool-button-filter'>
          {filterDrawerOpen
              ? <Icon
                  path="./icons/ui/grey/close-07.svg"
                  size="s"
                />
              : <Icon
                  path="./icons/ui/grey/menu-07.svg"
                  size="s"
                />
          }
        </HeaderActionIcon>
        <HeaderActionText>
          {i18n.filter}
        </HeaderActionText>
      </HeaderActionButton>

      <HeaderSearchButton data-testid='tool-button' onClick={handleSearchOpenClick}>
        <HeaderActionIcon data-testid='tool-button-search'>
        <Icon
          path="./icons/ui/grey/search-07.svg"
          size="s"
        />
        </HeaderActionIcon>
      </HeaderSearchButton>

      {children}

    </HeaderActionsBlock>
  )
}

export { HeaderActionsComponent }
